module.exports = __webpack_public_path__ + "img/alentour29.5713ec82.jpg";